import { Box, Typography } from "@mui/material";
import { useTranslation } from "next-i18next";
import { PopoverButtonIconInfo } from "src/components-mui/base/wf-popover/popover-button-icon-info";
import { WfPopover } from "src/components-mui/base/wf-popover/wf-popover";
import { ITooltip } from "src/types/common";

interface ICBHeaderNotInvestibleProps {
    tooltip: ITooltip | undefined;
}
export const CBHeaderNotInvestible = ({ tooltip }: ICBHeaderNotInvestibleProps) => {
    const { t } = useTranslation("wf-detail");

    return (
        <Box
            py={2}
            px={2}
            flexDirection="column"
            width="100%"
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ backgroundColor: "gray.50" }}
        >
            <Typography component="h3" fontWeight="bold" textAlign="center">
                {t("headlines.wikifolio-certificate")}
            </Typography>

            <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography color="gray.600" fontSize="xs">
                    {t("certificate.header.not-investable")}
                </Typography>
                {tooltip && (
                    <WfPopover
                        content={tooltip.content}
                        link={tooltip.link}
                        PopoverTrigger={<PopoverButtonIconInfo ariaLabel={t("certificate.header.not-investable")} color="gray200" sx={{ ml: 0.5 }} />}
                    />
                )}
            </Box>
        </Box>
    );
};
